import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import { withRouter } from 'react-router-dom';
import _uniq from 'lodash/uniq';
import superagent from 'superagent';

import autosuggestHighlightMatch from 'autosuggest-highlight/match';
import autosuggestHighlightParse from 'autosuggest-highlight/parse';
import { Button } from 'module-tsl-ui-elements';
import { InputGroup } from 'module-tsl-ui-elements';
import { mzEmit } from '../../../app/helpers';

const MAX_SUGGESTIONS = 10;
const TYPE_DURATION = 300; // ms

const sorter = (a, b) => {
  if (a.description > b.description) return 1;
  if (a.description < b.description) return -1;
  return 0;
};

function getSuggestionDisplayName(suggestion) {
  return suggestion.nameParts.join(' / ');
}

function getPhaseName(suggestion) {
  return suggestion.phase ? suggestion.phase.name + ' ' : '';
}

class KeywordInputGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      clickSelected: false,
      keywords: props.keywords,
    };
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.createTypingHandler();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.keywords && !nextProps.keywords) this.setState({suggestions: []});
    if (nextProps.keywords !== this.setState.keywords) this.setState({keywords: nextProps.keywords});
  }

  componentDidUpdate() {
    if (this.state.clickSelected) {
      setTimeout( () => document.querySelector('#search-jobs button[type=submit]').click() );
    }
  }

  changedKeywords(keywords) {
    const { changedKeywords } = this.props;
    this.setState({ keywords });
    changedKeywords(keywords);
  }

  onSuggestionSelected(event, { method, suggestionValue }) {
    mzEmit({ eventTitle: 'jobs.v2.autoSuggest', payload: { method, suggestionValue } });
    this.setState({clickSelected: true});
  }

  onSuggestionsRequested({ value }) {
    this.getSuggestionsFromAutocompleteApi(value.replace(/\s+/g, '_').toLowerCase());
  }

  getSuggestions(value, searchList) {
    const searchQuery = value.trim();
    if (searchQuery.length === 0) return [];

    const exactMatches = searchList.filter((searchItem) => (new RegExp(searchItem.description, 'i')).test(searchQuery.substr(0, searchQuery.length - 1)));
    const matchedFacetTypes = Object.keys(exactMatches.reduce((p, c) => (p[c.type] = true) && p, {}));

    const primaryMatches = searchList.filter((searchItem) => (new RegExp('^' + searchQuery, 'i')).test(searchItem.description));
    if (exactMatches.length === 0) return primaryMatches.sort(sorter);

    const lastWordWithoutMatched = (exactMatches
      .reduce((p, c) => p.replace(new RegExp(c.description, 'gi'), ''), searchQuery)
      .trim()
      .split(' ')
      .pop()
    ) || searchQuery.split(' ').pop();

    const matchedQuery = exactMatches.reduce((p, c) => {
      return p.replace(new RegExp(c.description, 'gi'), c.description);
    }, searchQuery);

    const queryWithoutLastWord = matchedQuery.substr(0, matchedQuery.lastIndexOf(' '));

    return searchList
      .filter((searchItem) => ((new RegExp('^' + lastWordWithoutMatched, 'i')).test(searchItem.description)) && matchedFacetTypes.indexOf(searchItem.type) < 0)
      .map(e => Object.assign({}, { description: _uniq(`${queryWithoutLastWord} ${e.description}`.split(' ')).join(' ').trim() }))
      .concat(primaryMatches)
      .reduce((p, c) => {
        if (!p.cache[c.description]) p.items.push(c);
        p.cache[c.description] = true;
        return p;
      }, {
        cache: {},
        items: []
      }).items
      .sort(sorter);
  }

  getSuggestionValue(suggestion) {
    return suggestion.name;
  }

  renderSuggestion(suggestion, { query }) {
    const suggestionText = getSuggestionDisplayName(suggestion);
    const matches = autosuggestHighlightMatch(suggestionText, query);
    const parts = autosuggestHighlightParse(suggestionText, matches);
    return (<div>
              <span style={{color: '#AAA'}}>{getPhaseName(suggestion)}</span>
              <span>{parts.map((part, index) => {
                const className = part.highlight ? null : 'react-autosuggest__highlight';
                return (
                  <span className={className} key={index}>{part.text}</span>
                );
              })}</span>
            </div>);
  }

  render() {
    const { isMobile } = this.props;
    const { keywords } = this.state;
    if (this.state.clickSelected) {
      this.setState({clickSelected: false});
    }
    if (isMobile) {
      return (<div className="margin-bottom-md">
        <InputGroup self={{groupId: '1'}}
        cta={
          <Button
            data-mz
            data-module="search-section"
            theme="primary"
            // className="t-search-button"
            type="submit"
          >
            Search
          </Button>}
        customInput={
          <Autosuggest
            id="job-search"
            suggestions={this.state.suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsRequested.bind(this)}
            onSuggestionsClearRequested={ () => {}}
            renderSuggestion={this.renderSuggestion}
            getSuggestionValue={this.getSuggestionValue}
            onSuggestionSelected={this.onSuggestionSelected}
            inputProps = {{
              id: 'resource-search',
              type: 'search',
              className: 'keyword-input tes-control t-keywords-jobs',
              name: 'keywords',
              placeholder: isMobile ? 'Enter job title or keyword' : 'Search jobs by keyword',
              value: keywords,
              onChange: (evt, {newValue}) => this.changedKeywords(newValue),
              maxLength: 255
            }}
          />}
        />
      </div>);
    }

    return (<div className="margin-bottom-md">
        <label htmlFor="job-search" className="sr-only">Keywords</label>
        <Autosuggest
          id="job-search"
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsRequested.bind(this)}
          onSuggestionsClearRequested={ () => {}}
          renderSuggestion={this.renderSuggestion}
          getSuggestionValue={this.getSuggestionValue}
          onSuggestionSelected={this.onSuggestionSelected}
          inputProps = {{
            id: 'resource-search',
            type: 'search',
            className: 'keyword-input tes-control t-keywords-jobs',
            name: 'keywords',
            placeholder: 'Search jobs by keyword',
            value: keywords,
            onChange: (evt, {newValue}) => this.changedKeywords(newValue),
            maxLength: 255
          }}
        />
      </div>
    );
  }

  createTypingHandler() {
    const getUnique = (suggArr) => {
      const cache = {};
      suggArr.forEach(s => {
        cache[s.name] = s;
      });
      return Object.keys(cache).map(key => cache[key]);
    };
    let timer = null;
    this.getSuggestionsFromAutocompleteApi = _keywords => {
      const keywords = _keywords.replace(/( |_)/g, '');
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timer = setTimeout(() => {
        superagent(`/api/autocomplete/jobsKeywordsSmall?l=100&q=${keywords}`).then(res => {
          const rawSuggestions = getUnique(res.body.results);
          rawSuggestions.sort((a, b) => a.rank > b.rank ? 1 : -1);
          if (rawSuggestions.length >= MAX_SUGGESTIONS) {
            this.setState({suggestions: rawSuggestions.slice(0, MAX_SUGGESTIONS).map(s => ({
              name: s.name,
              nameParts: [s.name]
            }))});
            return null;
          }
          return superagent(`/api/autocomplete/jobsKeywords?l=100&q=${keywords}`).then(resLarge => {
            const rawLargeSuggestions = getUnique(resLarge.body.results.concat(rawSuggestions));
            rawLargeSuggestions.sort((a, b) => a.rank > b.rank ? 1 : -1);
            this.setState({suggestions: rawLargeSuggestions.slice(0, MAX_SUGGESTIONS).map(s => ({
              name: s.name,
              nameParts: [s.name]
            }))});
          });
        }).catch(console.error); // eslint-disable-line
      }, TYPE_DURATION);
    };
  }

}

KeywordInputGroup.propTypes = {
  keywords: PropTypes.string,
  searchList: PropTypes.array,
  changedKeywords: PropTypes.func,
  isMobile: PropTypes.bool
};

KeywordInputGroup.defaultProps = {
  keywords: ''
};

export default withRouter(KeywordInputGroup);
